import { useState } from 'react'
import { Stack } from '@chakra-ui/react'
import { COLORS } from 'utils/styles'
import { CreateComment } from './CreateComment'
import { CommentsList } from './CommentsList'

export const Comments = ({ GoToMarker }) => {
  const [editCommentData, setEditCommentData] = useState({})

  return (
    <Stack
      padding="10px 5px 10px 5px"
      background={COLORS.darkGray}
      minHeight="100%"
    >
      <Stack>
        <CreateComment
          editCommentData={editCommentData}
          setEditCommentData={setEditCommentData}
        />

        <CommentsList
          GoToMarker={GoToMarker}
          setEditCommentData={setEditCommentData}
        />
      </Stack>
    </Stack>
  )
}
